import { gql } from "@apollo/client";

const GET_PURCHASER = gql`
  query GetPurchaser($params: GetPurchaserParams!) {
    purchasers(params: $params) {
      count
      items {
        purchaserId
        purchaserKey
        purchaserName
      }
    }
  }
`;

export default GET_PURCHASER;
